<template>
  <div
    class="conversation-item p-4 hover:bg-gray-700 cursor-pointer transition-colors relative group"
    :class="{ 'bg-gray-700': isActive }"
    @click="$emit('click')"
  >
    <div class="flex items-start space-x-3">
      <div class="flex-shrink-0">
        <div
          class="h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center text-white"
        >
          {{ userInitials }}
        </div>
      </div>

      <div class="flex-1 min-w-0">
        <div class="flex justify-between items-baseline">
          <h3 class="text-white font-medium truncate">
            {{ conversation.otherUser.username }}
          </h3>
          <span class="text-xs text-gray-400">
            {{ formatDate(conversation.lastMessage.createdAt) }}
          </span>
        </div>

        <p class="text-gray-300 text-xs truncate mt-1">
          {{ conversation.product.name }}
        </p>

        <p class="text-gray-300 text-sm truncate mt-1">
          {{ conversation.lastMessage.content }}
        </p>
      </div>
    </div>

    <div v-if="conversation.unreadCount > 0" class="mt-2 flex justify-end">
      <span
        class="bg-blue-600 text-white text-xs rounded-full px-2 py-1 min-w-5 text-center"
      >
        {{ conversation.unreadCount }}
      </span>
    </div>

    <!-- Delete button, visible on hover -->
    <button
      @click.stop="$emit('delete')"
      class="absolute right-2 top-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 bg-red-600 text-white rounded hover:bg-red-700"
      title="Obriši konverzaciju"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="3 6 5 6 21 6"></polyline>
        <path
          d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
        ></path>
      </svg>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';
import { Conversation } from '@/types/chat-types';

export default defineComponent({
  name: 'ConversationItem',
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click', 'delete'],
  setup(props) {
    const userInitials = computed(() => {
      const username = props.conversation.otherUser.username;
      return username.charAt(0).toUpperCase();
    });

    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      const now = new Date();

      // Isti dan
      if (date.toDateString() === now.toDateString()) {
        return date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        });
      }

      // U poslednjih 7 dana
      const diffDays = Math.floor(
        (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24)
      );
      if (diffDays < 7) {
        const days = ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'];
        return days[date.getDay()];
      }

      // Starije poruke
      return date.toLocaleDateString();
    };

    return {
      userInitials,
      formatDate,
    };
  },
});
</script>
